import type { Moment } from "moment";
import type { MarketingAction } from "src/types/action/MarketingAction";
import type { MarketingActionPos } from "src/types/action/MarketingActionPos";
import type { ThirdServiceCategory } from "src/types/posCredential";
import type { SponsoredAdScenario } from "src/types/sponsored-ads/SponsoredAdScenario";
import type { Channel } from "../channel";
import type { IdName } from "../IdName";
import type { Offer } from "../offer";
import type { Pos } from "../pos";

export interface SponsoredAdRecurrence extends IdName {
    isWeekly: boolean;
}

export enum SponsoredRecurrenceEnum {
    Once = 1,
    AllDays = 2,
    AllWeekdays = 3,
    WeeklyDay = 4,
    Custom = 5,
}

export const BID_AUTO_VALUE = -1;

export interface SponsoredAdPosMarketingActions extends MarketingActionPos {
    id: number;
    createdDateUTC: Date;
    pos: Pos;
    posId: number;
    isActiveLink: boolean;
    unlinkedDateUTC: Date;
}

export interface SponsoredAdCreation {
    pos: IdName[];
    now: string;
    ending: string;
    startDate: Moment;
    endDate: Moment;
    startTime: string;
    endTime: string;
    days: number[];
    bid: number;
    slotBudget: number;
    channel: Channel;
    audience?: number;
    recurrence: SponsoredRecurrenceEnum;
    confirm: boolean;
}

export interface SponsoredAd extends MarketingAction {
    id: number;
    createdDateUTC: string;
    endDate: string;
    startTime: string;
    endTime: string;
    posMarketingActions?: SponsoredAdPosMarketingActions[];
    channel: Channel;
    service: ThirdServiceCategory;
    duoMarketingActionId: number;
    duoMarketingAction: Offer;
    durationStartFromMidnight: string;
    durationEndFromMidnight: string;
    mainScenario?: SponsoredAdScenario;
    scenarios: SponsoredAdScenario[];
}
